import React from 'react';
import cloneObject from './cloneObject';
import { isAnObject } from './isAnObject';

export default function cloneArray(array: any[] = []): any[] {
    return array.map(element => {
        if (React.isValidElement(element))
            return element;
        if (isAnObject(element))
            return cloneObject(element);
        if (Array.isArray(element))
            return cloneArray(element);
        return element;
    });
}
